export default __webpack_public_path__ + "media/zurb/img/bryan/thumbs/2-98e70e1531d9e3b9e6cad042a91857f5.png";